export { default as MainLogo } from './logos/MainLogo'
export { default as LoyaltyLogo } from './logos/LoyaltyLogo'
export { LogoVariant, LogoSurface, LogoSize } from './types'
